import type AiCostLimitAlertView from '@UI/Store/AiCostLimitAlerts/Views/AiCostLimitAlertView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AiCostLimitAlertsListView {
	readonly accountId: number;
	readonly list: readonly AiCostLimitAlertView[];

	constructor(accountId: number, list: readonly AiCostLimitAlertView[]) {
		this.accountId = accountId;
		this.list = list;

		Object.freeze(this);
	}
}

export default AiCostLimitAlertsListView;
